import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  
  useEffect(() => {
    if (!isLoggedIn) return;
    /*
    const handleUnload = () => {
      navigator.sendBeacon("/api/front/logout", {});
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
    */
  }, [isLoggedIn]);

  return (
    <>
      {/* Header / Sidebar */}
      <Outlet />
    </>
  );
};

export default AppLayout;
